import { render, staticRenderFns } from "./eod-contacts.vue?vue&type=template&id=c5d717a6"
import script from "./eod-contacts.vue?vue&type=script&lang=js"
export * from "./eod-contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports